define("madIsTouchDevice",["jquery"],(function(){"use strict";return{isTouchDevice:function(){try{return document.createEvent("TouchEvent"),!0}catch(e){return!1}}}}));
